import React, { useState, useEffect } from "react";
import ModalImage from "react-modal-image";
import api from "../../services/api";

const ModalImageCors = ({ imageUrl }) => {
  const [fetching, setFetching] = useState(true);
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    if (!imageUrl) return;
    const fetchImage = async () => {
      const { data, headers } = await api.get(imageUrl, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([data], { type: headers["content-type"] }));
      setBlobUrl(url);
      setFetching(false);
    };
    fetchImage();
  }, [imageUrl]);

  const src = fetching ? imageUrl : blobUrl;

  return (
    <ModalImage
      className="w-[250px] h-[200px] object-cover rounded-lg"
      smallSrcSet={src}
      medium={src}
      large={src}
      alt="image"
    />
  );
};

export default ModalImageCors;
